import styled from "styled-components";

export const MyButton = styled.button`
  background: ${({ primary }) => (primary ? "#FBBC56" : "#071242")};
  font-size: 14px;
  border-radius: 12px;
  min-width: 140px;
  width: fit-content;
  white-space: nowrap;
  padding: 0 30px;
  height: 40px;
  color: #fff;
  text-align: center;
  font-weight: bold;
  outline: none;
  border: none;
  &:not(:disabled):hover {
    background: ${({ primary }) => (primary ? "#071242" : "#FBBC56")};
  }
  transition: background 0.3s ease-out;
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
